<div class="headline">
  <span class="mat-h1" style="margin: 0;">Passwort ändern</span>
</div>
<hr>

<br>

Bitte tragen Sie das neue Passwort in beide untenstehende Felder ein.<br><br>

<form (keyup.enter)="changePassword()" (ngSubmit)="changePassword()" tabindex="0" [formGroup]="resetPasswordForm">
  <mat-form-field appearance="outline" class="w20 marg-right2">
    <mat-label>Neues Passwort</mat-label>
    <input [type]="hideCurrentPw ? 'password' : 'text'" formControlName="newPassword" matInput placeholder="" required
           autocomplete="new-password">
    <mat-icon (click)="hideCurrentPw = !hideCurrentPw" matSuffix>{{hideCurrentPw ? 'visibility_off' : 'visibility'}}</mat-icon>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w20">
    <mat-label>Passwort wiederholen</mat-label>
    <input [type]="hideNewPw ? 'password' : 'text'" formControlName="newPasswordRepeated" matInput placeholder=""
           required autocomplete="new-password">
    <mat-icon (click)="hideNewPw = !hideNewPw" matSuffix>{{hideNewPw ? 'visibility_off' : 'visibility'}}</mat-icon>
  </mat-form-field>
</form>

Sie müssen sich anschließend mit Ihrem neuen Passwort erneut anmelden!

<br>
<br>

<button (click)="changePassword()" color="primary" mat-button mat-raised-button>Speichern</button>
